(function () {
  'use strict';

  // -----------------------------
  // Configuration
  // -----------------------------
  var RESTRICTED_VEHICLE_MATCHERS = [
    '2019-2026 chevrolet/gmc 1500 - 6x139.7/78.1mm cb',
    '2011-2026 dodge/ram 4500/5500 - 10x225/170.1mm cb',
    '2005-2026 ford f-450/f-550 drw - 10x225/170.1mm cb'
  ];

  var RESTRICTED_SIZES = [
    '20x9/0mm et',
    '20x10/-25mm et',
    '20x12/-40mm et',
    '20x14/-73mm et',
    '20x12/-60mm et',
    '20x8.25"/145mm et'
  ];

  var POPUP_MESSAGE =
    'Your vehicle is not compatible with the selected wheel size, <span class="wdr-strong">20" diameter</span>. ' +
    'Please select a <span class="wdr-strong">22" or larger</span> wheel diameter for your vehicle, thank you.';

  var DEBUG = false;

  var variantSelector = null;
  var hasShownPopupForCurrentCombo = false;
  var lastStateKey = '';

  // -----------------------------
  // Styles
  // -----------------------------
  function injectStyles() {
  if (document.getElementById('wdr-styles')) return;
  var style = document.createElement('style');
  style.id = 'wdr-styles';
  style.textContent = [
    '@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap");',

    '.wdr-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.75);z-index:99998;}',

    '.wdr-modal{',
      'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);',
      'z-index:99999;width:90%;max-width:400px;',
      'background:#CDCDCD;border-radius:4px;overflow:hidden;',
      'box-shadow:0 0 0 1px #b0b0b0;font-family:Arial,sans-serif;',
    '}',

    '.wdr-header{',
      'background:#111111;padding:18px 22px;',
      'display:flex;align-items:center;justify-content:center;gap:14px;',
    '}',

    '.wdr-icon{',
      'width:34px;height:34px;border-radius:50%;background:#B1282E;',
      'display:flex;align-items:center;justify-content:center;flex-shrink:0;',
    '}',

    '.wdr-icon svg{display:block;}',

    '.wdr-title{',
      'font-family:"Bebas Neue",Impact,sans-serif;',
      'color:#fff !important;font-size:34px;letter-spacing:0px;line-height:1;',
    '}',

    '.wdr-bar{height:3px;background:#B1282E;}',

    '.wdr-body{padding:20px 22px 16px;text-align:center;}',

    '.wdr-desc{',
      'font-family:"Bebas Neue",Impact,sans-serif;',
      'font-size:24px;letter-spacing:0px;color:#444;line-height:1.55;',
      'margin:0 0 16px;',
    '}',

    '.wdr-strong{color:#111 !important;}',

    '.wdr-subheading{',
      'font-family:"Bebas Neue",Impact,sans-serif;',
      'font-size:21px;letter-spacing:0px;color:#111;',
      'margin:0 0 10px;',
    '}',

    '.wdr-chips{display:flex !important;flex-wrap:wrap;gap:7px;justify-content:center;}',

    '.wdr-chips a{',
      'display:inline-block !important;',
      'color:#fff !important;',
      'background:#B1282E !important;',
      'font-family:"Bebas Neue",Impact,sans-serif !important;',
      'font-size:19px !important;',
      'letter-spacing:0px !important;',
      'text-decoration:none !important;',
      'padding:6px 13px !important;',
      'border-radius:3px !important;',
      'line-height:1.3 !important;',
    '}',

    '.wdr-footer{',
      'padding:14px 22px 22px;',
      'border-top:1px solid #b8b8b8;',
    '}',

    '.wdr-btn{',
      'width:100%;background:#111;color:#fff;border:none;border-radius:3px;',
      'padding:13px;cursor:pointer;',
      'font-family:"Bebas Neue",Impact,sans-serif;',
      'font-size:24px;letter-spacing:0px;',
    '}',

    '.wdr-btn:focus-visible{outline:3px solid #B1282E;outline-offset:3px;}',

    '@media(max-width:480px){',
      '.wdr-title{font-size:22px;}',
      '.wdr-desc{font-size:17px;}',
      '.wdr-subheading{font-size:17px;}',
      '.wdr-chips a{font-size:16px !important;}',
      '.wdr-btn{font-size:20px;}',
    '}'

  ].join('');
  document.head.appendChild(style);
}

  // -----------------------------
  // Helpers
  // -----------------------------
  function norm(s) {
    return String(s || '')
      .trim()
      .toLowerCase()
      .replace(/[""]/g, '"')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ');
  }

  function getVariantSelectorFresh() {
    return document.querySelector('select[name="option1"]');
  }

  function getSelectedSnapshot() {
    var parts = [];

    var propInputsGlobal = document.querySelectorAll('[name^="properties["]');
    for (var i = 0; i < propInputsGlobal.length; i++) {
      var inp = propInputsGlobal[i];
      if (!inp) continue;
      var val = '';
      if (inp.type === 'checkbox') {
        if (!inp.checked) continue;
        val = inp.value || 'true';
      } else if (inp.type === 'radio') {
        if (!inp.checked) continue;
        val = inp.value || '';
      } else {
        val = inp.value || '';
      }
      val = norm(val);
      if (val) parts.push(val);
    }
    if (parts.length) return parts.join(' | ');

    var els = document.querySelectorAll('.po-dropdown-selected-option');
    for (var j = 0; j < els.length; j++) {
      var t = norm(els[j].textContent);
      if (t) parts.push(t);
    }
    if (parts.length) return parts.join(' | ');

    var generic = document.querySelectorAll(
      '[data-selected-value], .selected-value, .option-selected, .swatch__selected'
    );
    for (var k = 0; k < generic.length; k++) {
      var t2 = norm(
        generic[k].textContent || generic[k].getAttribute('data-selected-value')
      );
      if (t2) parts.push(t2);
    }

    return parts.join(' | ');
  }

  function isRestrictedVehicleSelected(snapshot) {
    var snap = snapshot || getSelectedSnapshot();
    for (var i = 0; i < RESTRICTED_VEHICLE_MATCHERS.length; i++) {
      if (snap.indexOf(norm(RESTRICTED_VEHICLE_MATCHERS[i])) !== -1) return true;
    }
    return false;
  }

  function isRestrictedSizeSelected() {
    variantSelector = getVariantSelectorFresh();
    if (!variantSelector) return false;
    var current = norm(variantSelector.value);
    for (var i = 0; i < RESTRICTED_SIZES.length; i++) {
      if (norm(RESTRICTED_SIZES[i]) === current) return true;
    }
    return false;
  }

  // -----------------------------
  // UI: disable/enable wheel options
  // -----------------------------
  function disableRestrictedOptions() {
    variantSelector = getVariantSelectorFresh();
    if (!variantSelector) return;
    var options = variantSelector.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      var optVal = norm(opt.value);
      for (var j = 0; j < RESTRICTED_SIZES.length; j++) {
        if (norm(RESTRICTED_SIZES[j]) === optVal) {
          opt.disabled = true;
          opt.style.textDecoration = 'line-through';
          opt.style.color = '#999';
          break;
        }
      }
    }
  }

  function enableAllOptions() {
    variantSelector = getVariantSelectorFresh();
    if (!variantSelector) return;
    var options = variantSelector.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      opt.disabled = false;
      opt.style.textDecoration = 'none';
      opt.style.color = '';
    }
  }

  // -----------------------------
  // Add to Cart blocking
  // -----------------------------
  function getAddToCartButtons() {
    return document.querySelectorAll(
      'form[action^="/cart/add"] [type="submit"], ' +
      'form[action^="/cart/add"] button[name="add"], ' +
      'button[name="add"], ' +
      'button[type="submit"][name="add"]'
    );
  }

  function setAddToCartDisabled(disabled) {
    var buttons = getAddToCartButtons();
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      btn.disabled = !!disabled;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      if (disabled) {
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
      } else {
        btn.style.opacity = '';
        btn.style.cursor = '';
      }
    }
  }

  function preventAddToCartWhenRestricted() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action^="/cart/add"]')) return;
      var snap = getSelectedSnapshot();
      var restrictedVehicle = isRestrictedVehicleSelected(snap);
      var restrictedSize = isRestrictedSizeSelected();
      if (restrictedVehicle && restrictedSize) {
        e.preventDefault();
        e.stopPropagation();
        hasShownPopupForCurrentCombo = false;
        checkRestrictions(snap);
        return false;
      }
    }, true);

    var originalFetch = window.fetch;
    if (originalFetch) {
      window.fetch = function () {
        try {
          var url = arguments[0];
          var urlStr = typeof url === 'string' ? url : (url && url.url) ? url.url : '';
          if (urlStr && (urlStr.indexOf('/cart/add') !== -1 || urlStr.indexOf('/cart/add.js') !== -1)) {
            var snap2 = getSelectedSnapshot();
            var restrictedVehicle2 = isRestrictedVehicleSelected(snap2);
            var restrictedSize2 = isRestrictedSizeSelected();
            if (restrictedVehicle2 && restrictedSize2) {
              hasShownPopupForCurrentCombo = false;
              checkRestrictions(snap2);
              return Promise.reject(new Error('Restricted combination blocked.'));
            }
          }
        } catch (err) {}
        return originalFetch.apply(this, arguments);
      };
    }
  }

  // -----------------------------
  // Popup
  // -----------------------------
  function showPopup() {
    if (document.querySelector('.wdr-modal') || hasShownPopupForCurrentCombo) return;
    hasShownPopupForCurrentCombo = true;

    // Remember what was focused before opening, so we can restore it on close
    var previouslyFocused = document.activeElement;

    var overlay = document.createElement('div');
    overlay.className = 'wdr-overlay';

    var modal = document.createElement('div');
    modal.className = 'wdr-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'wdr-title');
    modal.setAttribute('aria-describedby', 'wdr-desc');
    modal.setAttribute('tabindex', '-1');

    modal.innerHTML =
      '<div class="wdr-header">' +
        '<div class="wdr-icon" aria-hidden="true">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">' +
            '<circle cx="12" cy="12" r="10"/>' +
            '<line x1="12" y1="8" x2="12" y2="12"/>' +
            '<line x1="12" y1="16" x2="12.01" y2="16"/>' +
          '</svg>' +
        '</div>' +
        '<span class="wdr-title" id="wdr-title">FITMENT RESTRICTION</span>' +
      '</div>' +
      '<div class="wdr-bar"></div>' +
      '<div class="wdr-body">' +
        '<p class="wdr-desc" id="wdr-desc">' + POPUP_MESSAGE + '</p>' +
      '</div>' +
      '<div class="wdr-footer">' +
        '<button type="button" class="wdr-btn" aria-label="Acknowledge fitment restriction and close dialog">GOT IT</button>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    var btn = modal.querySelector('.wdr-btn');

    // Auto-focus the GOT IT button so screen readers announce the dialog
    if (btn) btn.focus();

    // Focus trap + ESC key handler
    function handleKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closePopup();
        return;
      }
      // Only one focusable element (the GOT IT button), so just keep focus on it
      if (e.key === 'Tab') {
        e.preventDefault();
        if (btn) btn.focus();
      }
    }

    document.addEventListener('keydown', handleKeydown);

    function closePopup() {
      document.removeEventListener('keydown', handleKeydown);
      if (document.body.contains(overlay)) document.body.removeChild(overlay);
      if (document.body.contains(modal)) document.body.removeChild(modal);
      // Restore focus to whatever was focused before the modal opened
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
      setTimeout(disableRestrictedOptions, 50);
    }

    if (btn) btn.addEventListener('click', closePopup);
    overlay.addEventListener('click', closePopup);
  }

  // -----------------------------
  // Core logic
  // -----------------------------
  function checkRestrictions(snapshot) {
    variantSelector = getVariantSelectorFresh();
    var snap = snapshot || getSelectedSnapshot();
    var restrictedVehicle = isRestrictedVehicleSelected(snap);
    var restrictedSize = isRestrictedSizeSelected();

    if (DEBUG) {
      try {
        console.log('[Wheel Restrict] snapshot=', snap);
        console.log('[Wheel Restrict] option1=', variantSelector ? variantSelector.value : '(missing)');
        console.log('[Wheel Restrict] restrictedVehicle=', restrictedVehicle, 'restrictedSize=', restrictedSize, 'shown=', hasShownPopupForCurrentCombo);
      } catch (e) {}
    }

    setAddToCartDisabled(restrictedVehicle && restrictedSize);

    if (restrictedVehicle) {
      disableRestrictedOptions();
      if (restrictedSize && !hasShownPopupForCurrentCombo) showPopup();
    } else {
      enableAllOptions();
    }
  }

  // -----------------------------
  // Watchers
  // -----------------------------
  function startStateWatcher() {
    setInterval(function () {
      variantSelector = getVariantSelectorFresh();
      var snap = getSelectedSnapshot();
      var size = variantSelector ? norm(variantSelector.value) : '';
      var stateKey = snap + ' || ' + size;
      if (stateKey !== lastStateKey) {
        lastStateKey = stateKey;
        hasShownPopupForCurrentCombo = false;
        checkRestrictions(snap);
      }
    }, 250);
  }

  function bindSelectChange() {
    variantSelector = getVariantSelectorFresh();
    if (!variantSelector) return;
    variantSelector.addEventListener('change', function () {
      hasShownPopupForCurrentCombo = false;
      setTimeout(checkRestrictions, 100);
    });
  }

  // -----------------------------
  // Init
  // -----------------------------
  function init() {
    variantSelector = getVariantSelectorFresh();
    if (!variantSelector) {
      setTimeout(init, 500);
      return;
    }
    injectStyles();
    bindSelectChange();
    preventAddToCartWhenRestricted();
    startStateWatcher();
    checkRestrictions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();